import { render, staticRenderFns } from "./GastroVisitaProctologicaList.vue?vue&type=template&id=5b6a0f77"
import script from "./GastroVisitaProctologicaList.vue?vue&type=script&lang=js"
export * from "./GastroVisitaProctologicaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports